<template>
    <div class="light-color-bg position-relative">
        <QuestionTitle number="02" :question="question" ></QuestionTitle>
        <div class="container-70 mt-20px">
            <SelectOptionBox :img="imgAlimentation" :options="options" v-model="result"></SelectOptionBox>
            <div  v-if="result!=null"  @click="saveAndContinue('nbMonth', JSON.stringify(result), './question-3')" class="btn-primary d-block w-100 mt-50px text-center">Suivant</div>
            <AvancementLine  class="mt-50px" percent="80%"></AvancementLine>
        </div>
    </div>
</template>
<script>
import QuestionTitle from '@/components/QuestionTitle.vue'
import AvancementLine from '@/components/AvancementLine.vue'
import SelectOptionBox from '@/components/SelectOptionBox.vue'
/*Mixins*/
import utils from '@/mixins/utils'
export default {
    data() {
        return {
            result:null,
            modalActive:false,
            question:'Sur quelle période désirez-vous calculer vos émissions de GES?',
            imgAlimentation:require('@/assets/images/calendar.png'),
            options:[
                {
                    label:"1 mois",
                    value:"1 mois"
                },
                {
                    label:"2 mois",
                    value:"2 mois"
                },
                {
                    label:"3 mois",
                    value:"3 mois"
                },
                {
                    label:"4 mois",
                    value:"4 mois"
                },
                {
                    label:"5 mois",
                    value:"5 mois"
                },
                {
                    label:"6 mois",
                    value:"6 mois"
                },
                {
                    label:"7 mois",
                    value:"7 mois"
                },
                {
                    label:"8 mois",
                    value:"8 mois"
                },
                {
                    label:"9 mois",
                    value:"9 mois"
                },
                {
                    label:"10 mois",
                    value:"10 mois"
                },
                {
                    label:"11 mois",
                    value:"11 mois"
                },
                {
                    label:"12 mois",
                    value:"12 mois"
                }
            ]

        }
    },
    components: {
        QuestionTitle,
        AvancementLine,
        SelectOptionBox
    },
    mixins:[utils],
    mounted(){
        if(sessionStorage.getItem('nbMonth')){
            this.result=JSON.parse(sessionStorage.getItem('nbMonth'))
        }
    }
}
</script>